import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ArrowLeft, Mail, Zap } from 'lucide-react';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      
      <main className="pt-40 pb-20">
        <div className="max-w-md mx-auto px-6">
          <div className="text-center mb-10">
            <div className="w-16 h-16 bg-gradient-to-br from-vybe-600 to-vybe-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Zap className="w-8 h-8 text-white" />
            </div>
            <h1 className="font-display text-3xl text-white mb-2">Reset Password</h1>
            <p className="text-slate-400">We'll send you a reset link</p>
          </div>
          
          <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-8">
            {submitted ? (
              <div className="text-center py-6">
                <div className="w-14 h-14 bg-vybe-600/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <Mail className="w-6 h-6 text-vybe-400" />
                </div>
                <h2 className="font-display text-lg text-white mb-2">Check Your Email</h2>
                <p className="text-slate-400 text-sm mb-6">
                  We've sent a password reset link to <strong className="text-white">{email}</strong>
                </p>
                <Link to="/login" className="text-vybe-400 hover:text-vybe-300 text-sm font-medium transition-colors">
                  Return to sign in
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Label className="text-sm text-slate-300 font-medium">Email Address</Label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-2 bg-slate-900 border-slate-700 text-white placeholder-slate-500 focus:ring-vybe-500 focus:border-vybe-500 rounded-xl"
                    placeholder="your@email.com"
                    required
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="w-full py-4 bg-gradient-to-r from-vybe-600 to-vybe-500 hover:from-vybe-500 hover:to-vybe-400 text-white font-bold rounded-xl transition-all shadow-button"
                >
                  Send Reset Link
                </button>
              </form>
            )}
          </div>
          
          <Link 
            to="/login" 
            className="flex items-center justify-center gap-2 mt-6 text-slate-400 hover:text-vybe-400 text-sm transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to sign in
          </Link>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;
